import { computed } from 'vue'


export default {
  __name: 'CustomSelect',
  props: {
  disabled: {
    default: false,
    type: Boolean,
  },
  value: {
    type: Array,
    default: () => [],
  },
  itemText: {
    type: String,
    default: 'text',
  },
  itemValue: {
    type: String,
    default: 'value',
  },
  itemDisabled: {
    type: String,
    default: 'disabled',
  },
},
  emits: ['change', 'edit'],
  setup(__props, { emit }) {

const props = __props;





const selectedValues = computed(() =>
  props.value.map((e) => e[props.itemValue])
)

const valueMap = computed(() => {
  const map = new Map()
  props.value.forEach((v) => {
    map.set(v[props.itemValue], v)
  })
  return map
})

function getFullItem(item) {
  return valueMap.value.get(item[props.itemValue]) || item
}

function handleRemove(item) {
  const newValue = props.value
    .filter((v) => v[props.itemValue] !== item[props.itemValue])
    .map((v) => v[props.itemValue])
  emit('change', newValue)
}

return { __sfc: true,props, emit, selectedValues, valueMap, getFullItem, handleRemove }
}

}